var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 91,
    viewBox: "0 0 99 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_53_1338)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.5625 39.2873H37.6537L46.5019 29.6339C46.9156 29.1817 47.1147 28.5988 47.0552 28.0133C46.9958 27.4279 46.6828 26.8878 46.185 26.512C45.6872 26.1362 45.0455 25.9554 44.4009 26.0094C43.7564 26.0633 43.1619 26.3477 42.7481 26.7998L30.5606 40.0844C30.4786 40.19 30.4053 40.301 30.3412 40.4165C30.3412 40.5272 30.3413 40.5936 30.1706 40.7043C30.0601 40.9582 30.0023 41.2284 30 41.5014C30.0023 41.7744 30.0601 42.0446 30.1706 42.2985C30.1706 42.4092 30.1706 42.4756 30.3412 42.5863C30.4053 42.7017 30.4786 42.8127 30.5606 42.9184L42.7481 56.2029C42.9773 56.4529 43.2643 56.6539 43.5887 56.7916C43.9131 56.9294 44.2669 57.0005 44.625 57C45.1945 57.001 45.7465 56.8208 46.185 56.4908C46.4318 56.3049 46.6358 56.0766 46.7854 55.819C46.9349 55.5614 47.0271 55.2795 47.0565 54.9895C47.0859 54.6995 47.0521 54.4071 46.9569 54.129C46.8618 53.8509 46.7071 53.5926 46.5019 53.3689L37.6537 43.7155H66.5625C67.209 43.7155 67.829 43.4822 68.2861 43.067C68.7432 42.6518 69 42.0886 69 41.5014C69 40.9142 68.7432 40.351 68.2861 39.9358C67.829 39.5206 67.209 39.2873 66.5625 39.2873Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_53_1338",
    x: 0,
    y: 0,
    width: 99,
    height: 91,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_53_1338"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_53_1338",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.e32a42ca78e27358cc40f9d824c87a10.svg";
export { ForwardRef as ReactComponent };